<template>
  <div class="animated fadeIn profile-component main-div distinguished-class">
    <vLoading v-if="vLoading" />
    <div v-if="!notAllowed">
      <div v-if="pageLoaded">
        <v-row class="pt-1">
          <v-col sm="6" cols="12">
            <div class="pt-1 fs-small">
              <router-link to="/map" class="no-underline">
                <span class="c-primary"> انتخاب استان </span>
              </router-link>
              <v-icon>mdi-chevron-left</v-icon>
              <span @click="goToMap('state')" class="pointer">
                استان {{ researcherInfo.state }}
              </span>
              <v-icon>mdi-chevron-left</v-icon>
              <span @click="goToMap('researcher')" class="pointer">
                پژوهشگران برتر
              </span>
              <v-icon>mdi-chevron-left</v-icon>
              <span class="font-weight-bold">
                {{ researcherInfo.name + " " + researcherInfo.lastName }}
              </span>
            </div>
          </v-col>
          <v-col class="text-left" sm="6" cols="12">
            <v-btn
              @click="goToMap('state')"
              class="bc-primary text-white no-underline toMap-btn"
              ><span class="c-light">بازگشت به نقشه</span></v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-card class="common-card">
              <v-row>
                <v-col cols="12" class="d-flex flex-column flex-sm-row">
                  <div class="view-imageBox">
                    <img
                      :src="
                        researcherInfo.avatar
                          ? researcherInfo.avatar
                          : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                      "
                    />
                  </div>
                  <div class="d-flex flex-column ms-md-3 ms-0">
                    <h5 class="mt-1 c-dark fs-xxlarge">
                      <img class="star-icon" src="/icon-star.png" />
                      {{ researcherInfo.name + " " + researcherInfo.lastName }}
                    </h5>
                    <p class="ms-10 fs-medium mt-2">
                      <span class="me-1">دانشگاه/پژوهشکده محل اشتغال:</span>
                      <span
                        v-if="researcherInfo.universityJobId != notUniversity"
                        class="pointer blue--text lighten-2--text"
                        @click="
                          $router.push(
                            '/universityProfile/' +
                              researcherInfo.universityJobId
                          )
                        "
                      >
                        {{
                          researcherInfo.universityJobId
                            ? universities.filter(
                                (x) => x.id == researcherInfo.universityJobId
                              )[0]
                              ? universities.filter(
                                  (x) => x.id == researcherInfo.universityJobId
                                )[0].text
                              : "-"
                            : "-"
                        }}
                      </span>
                      <span v-else
                        >{{ researcherInfo.universityJobOther }}
                      </span>
                    </p>
                    <div
                      class="ms-10 fs-medium mt-2"
                      v-if="researcherInfo.catName"
                    >
                      <span class="me-1">موضوع پژوهش:</span>
                      <span
                        class="pointer blue--text lighten-2--text"
                        @click="goToCat()"
                        >{{ researcherInfo.catName }}
                      </span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-card class="common-card card-height">
              <h5 class="mt-1 c-dark fs-xxlarge">اطلاعات تماس پژوهشگر</h5>
              <div class="pt-4 c-grey">
                <v-icon class="pe-2">$Phone</v-icon>
                <span class="fs-medium">
                  شماره تماس محل کار:
                  {{
                    researcherInfo.officePhone
                      ? researcherInfo.officePhone
                      : "--"
                  }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="pe-2">$Email</v-icon>
                <span class="fs-medium">
                  آدرس ایمیل:
                  {{ researcherInfo.email ? researcherInfo.email : "--" }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <img src="/icons8-fax-24.png" class="pe-2" />
                <span class="fs-medium">
                  دورنگار:
                  {{ researcherInfo.fax ? researcherInfo.fax : "--" }}
                </span>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="common-card">
              <h5 class="mt-1 c-dark fs-xxlarge">جدول مدارج تحصیلی و تخصصی</h5>
              <div class="custom-table mt-8">
                <b-table
                  responsive
                  small
                  show-empty
                  stacked="sm"
                  tbody-tr-class="trClass"
                  thead-class="thClass"
                  :items="researcherInfo.educationDetails"
                  :fields="eduFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-card class="common-card card-height">
              <h5 class="mt-1 c-dark fs-xxlarge">
                فعالیت‌های انجام گرفته در زیست فناوری
              </h5>
              <div
                v-if="!researcherInfo.doneActivities"
                class="text-center my-12"
              >
                <hr />
                <span class="fs-small c-grey"
                  >توضیحی برای این قسمت ثبت نشده‌ است.</span
                >
                <hr />
              </div>
              <div v-else>
                <!-- inja -->
                <p
                  class="fs-medium text-justify ckeditor-style"
                  v-html="
                    researcherInfo.doneActivities.length > 450
                      ? researcherInfo.doneActivities.slice(0, 450) + '...'
                      : researcherInfo.doneActivities
                  "
                ></p>

                <div
                  v-if="researcherInfo.doneActivities.length > 450"
                  class="text-left mt-8"
                >
                  <v-btn
                    class="seeMore-btn"
                    @click="openSeeMoreModal('doneActivities')"
                    text
                  >
                    <span class="c-primary">مشاهده بیشتر</span>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-card class="common-card card-height">
              <h5 class="mt-1 c-dark fs-xxlarge">
                فعالیت‌های در دست انجام و برنامه‌ریزی شده
              </h5>
              <div
                v-if="!researcherInfo.inProgressActivities"
                class="text-center my-12"
              >
                <hr />
                <span class="fs-small c-grey"
                  >توضیحی برای این قسمت ثبت نشده‌ است.</span
                >
                <hr />
              </div>
              <div v-else>
                <!-- inja -->
                <p
                  class="fs-medium text-justify"
                  v-html="
                    researcherInfo.inProgressActivities.length > 450
                      ? researcherInfo.inProgressActivities.slice(0, 450) +
                        '...'
                      : researcherInfo.inProgressActivities
                  "
                ></p>

                <div
                  v-if="researcherInfo.inProgressActivities.length > 450"
                  class="text-left mt-8"
                >
                  <v-btn
                    class="seeMore-btn"
                    @click="openSeeMoreModal('inProgressActivities')"
                    text
                  >
                    <span class="c-primary">مشاهده بیشتر</span>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-card class="common-card card-height">
              <h5 class="mt-1 c-dark fs-xxlarge">مقالات حوزه زیست فناوری</h5>
              <div class="custom-table mt-8">
                <b-table
                  responsive
                  small
                  show-empty
                  stacked="sm"
                  tbody-tr-class="trClass"
                  thead-class="thClass"
                  :items="researcherInfo.articles"
                  :fields="articlesFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-card class="common-card card-height">
              <h5 class="mt-1 c-dark fs-xxlarge">
                اختراعات به ثبت رسیده در این حوزه
              </h5>
              <div class="custom-table mt-8">
                <b-table
                  responsive
                  small
                  show-empty
                  stacked="sm"
                  tbody-tr-class="trClass"
                  thead-class="thClass"
                  :items="researcherInfo.inventions"
                  :fields="inventionsFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-card class="common-card card-height">
              <h5 class="mt-1 c-dark fs-xxlarge">کتاب‌های به چاپ رسیده</h5>
              <div class="custom-table mt-8">
                <b-table
                  responsive
                  small
                  show-empty
                  stacked="sm"
                  tbody-tr-class="trClass"
                  thead-class="thClass"
                  :items="researcherInfo.books"
                  :fields="booksFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" xl="6">
            <v-card class="common-card card-height">
              <h5 class="mt-1 c-dark fs-xxlarge">گرنت‌های دریافت شده</h5>
              <div class="custom-table mt-8">
                <b-table
                  responsive
                  small
                  show-empty
                  stacked="sm"
                  tbody-tr-class="trClass"
                  thead-class="thClass"
                  :items="researcherInfo.grants"
                  :fields="grantFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-else>
      <v-row class="p-1">
        <v-col sm="6" cols="12"> &nbsp; </v-col>
        <v-col sm="6" cols="12" class="text-left">
          <v-btn to="/map" class="bc-primary text-white no-underline"
            ><span class="c-light">بازگشت به نقشه</span></v-btn
          >
        </v-col>
      </v-row>
      <v-card class="mt-3">
        <v-container>
          <hr />
          <h5 class="text-center">دسترسی به اطلاعات این پژوهشگر وجود ندارد</h5>
          <hr />
        </v-container>
      </v-card>
    </div>
    <v-dialog v-model="seeMoreModal" width="600">
      <v-card
        v-if="seeMoreType == 'doneActivities'"
        class="modal-card dark-modal"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">
                فعالیت‌های انجام گرفته در زیست فناوری
              </h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p
            class="c-grey fs-medium text-justify"
            style="line-height: 30px"
            v-html="researcherInfo.doneActivities"
          ></p>
        </v-container>
      </v-card>
      <v-card
        v-else-if="seeMoreType == 'inProgressActivities'"
        class="modal-card dark-modal"
      >
        <v-container class="p-4">
          <v-row class="mb-1">
            <v-col class="text-right">
              <h5 class="mt-1 c-dark fs-xxlarge">
                فعالیت‌های در دست انجام و برنامه‌ریزی شده
              </h5>
            </v-col>
            <v-col cols="2" class="text-left">
              <span @click="seeMoreModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>

          <p
            class="c-grey fs-medium text-justify"
            style="line-height: 30px"
            v-html="researcherInfo.inProgressActivities"
          ></p>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Chart from "/src/components/charts/Chart.vue";

export default {
  components: {
    Chart,
  },
  data() {
    return {
      city: "",
      model: 0,
      uniId: "",
      interval: {},
      busy: true,
      value: 0,
      researcherInfo: {},
      list: [],
      loaded: false,
      scienceCommitteeSize: "",
      type: "",
      optionsBar: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            rtl: true,
            display: true,
            position: "right",
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            scaleLabel: {
              display: true,
              labelString: "",
            },
            min: 0,
            ticks: {
              stepSize: 1,
              beginAtZero: true,
              font: { family: "iransans" },
            },
            stacked: true,
          },
          x: {
            stacked: true,
            ticks: {
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      supportsChart: {},
      isBusy: false,
      vLoading: false,
      notAllowed: false,
      seeMoreModal: false,
      universityId: "",
      seeMoreType: "",
      pageLoaded: false,
      eduFields: [
        { key: "index", label: "#" },
        { key: "eduGrade", label: "درجه تحصیلی" },
        { key: "eduField", label: "رشته تحصیلی" },
        { key: "uniName", label: "نام موسسه محل تحصیل" },
        { key: "country", label: "كشور محل تحصیل" },
        { key: "year", label: "سال دریافت" },
      ],
      articlesFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان مقاله" },
        { key: "publishDate", label: "تاریخ چاپ" },
        { key: "DOI", label: "DOI" },
      ],
      inventionsFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان" },
        { key: "submitDate", label: "تاریخ ثبت" },
      ],
      booksFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان" },
        { key: "publisher", label: "انتشارات" },
        { key: "publishDate", label: "تاریخ چاپ" },
      ],
      grantFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان گرنت" },
        { key: "subject", label: "موضوع فعالیت" },
        { key: "grantYear", label: "سال انجام پژوهش" },
      ],
      universities: [],
    };
  },
  methods: {
    openSeeMoreModal(type) {
      this.seeMoreType = type;
      this.seeMoreModal = true;
    },
    goToMap(to) {
      this.$router.push("/map");
      if (to == "state") {
        localStorage.setItem("state", this.researcherInfo.state);
        localStorage.setItem("stateId", this.researcherInfo.stateId);
      } else if (to == "researcher") {
        localStorage.setItem("state", this.researcherInfo.state);
        localStorage.setItem("stateId", this.researcherInfo.stateId);
        localStorage.setItem("item", "researcher");
      }
    },
    goToCat() {
      localStorage.setItem("catId", this.researcherInfo.catId);
      localStorage.setItem("catName", this.researcherInfo.catName);
      this.$router.push("/map");
    },
    getProfileInfo() {
      this.isBusy = true;
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/public/researcher/getInfo",
          {
            researcherId: this.$route.params.id,
          },
          {}
        )
        .then((res) => {
          if (window.screen.width < 850) {
            this.type = "mobile";
          } else {
            if (document.body.clientWidth < 850) {
              this.type = "mobile";
            } else {
              this.type = "desktop";
            }
          }

          this.researcherInfo = res.data;
          this.vLoading = false;
          this.pageLoaded = true;

          if (window.screen.width < 450 || document.body.clientWidth < 450) {
            this.scienceCommitteeSize = 3;
            this.optionsBar.plugins.legend.labels.font.size = "8";
            this.optionsBar.scales.x.ticks.font.size = "8";
            this.optionsBar.scales.y.ticks.font.size = "8";
          } else {
            this.scienceCommitteeSize = 4;
          }
          this.optionsBar.scales.y.ticks.stepSize =
            this.researcherInfo.requestDetailsStepSum;
          setTimeout(() => {
            this.loaded = true;
          }, 1000);
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.vLoading = false;
          if (err.response.status == 403) {
            this.notAllowed = true;
          } else {
            console.log(err);
            this.toast(err.response.data, "error");
          }
        });
    },
    checkWebsite() {
      if (
        this.researcherInfo.website.indexOf("http://") == 0 ||
        this.researcherInfo.website.indexOf("https://") == 0
      ) {
        return this.researcherInfo.website;
      } else {
        return "//" + this.researcherInfo.website;
      }
    },
    getUniversities() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: 1,
              text: "سایر دانشگاه ها",
            })
          );
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });
    },
  },
  computed: {
    showMehvarMoreBtn() {
      let temp;
      temp = this.researcherInfo.mehvars.filter((x) => x.name.length > 70);
      if (temp.length) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.researcherId = this.$route.params.id;
    this.getUniversities();
    this.getProfileInfo();
  },
};
</script>
<style lang="scss">
.modal-card {
  .mehvars-box {
    margin: 5px 0;
    max-height: 450px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: #eee;
      opacity: 0.5;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #bdbdbd;
      width: 10px;
      border-radius: 10px;
    }
  }
}
</style>
